import _ from 'lodash';
import {
  ADD_PHYSICIAN_GROUP_NOTE,
  ADD_PHYSICIAN_NOTE, GET_PHYSICIAN_GROUP_NOTES, GET_PHYSICIAN_GROUP_USERS,
  GET_PHYSICIAN_NOTES, GET_PHYSICIAN_SCRIPT, GET_PHYSICIAN_USERS, GET_PHYSICIAN_VISITS, GET_PHYSICIANS,
} from '../actions/physicians';

const initialState = {
  physiciansList: [],
  physicianScript: [],
  physicianScriptTotalPage: 1,
  physiciansTotalPage: 1,
  requestStatus: '',
  physicianUsers: [],
  physicianUsersTotalPage: 1,
  physicianNotes: [],
  physicianVisits: [],
  physicianGroupNotes: [],
  physicianGroupUsers: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PHYSICIANS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_PHYSICIANS.SUCCESS: {
      return {
        ...state,
        physiciansList: payload.data.data.response,
        physiciansTotalPage: payload.data.data._meta.pageCount,
        requestStatus: 'success',
      };
    }

    case GET_PHYSICIAN_SCRIPT.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_PHYSICIAN_SCRIPT.SUCCESS: {
      return {
        ...state,
        physicianScript: payload.data.data.response,
        physicianScriptTotalPage: payload.data.data._meta.pageCount,
        requestStatus: 'success',
      };
    }

    case GET_PHYSICIAN_USERS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_PHYSICIAN_USERS.SUCCESS: {
      return {
        ...state,
        physicianUsers: payload.data.data.response,
        physicianUsersTotalPage: payload.data.data._meta.pageCount,
        requestStatus: 'success',
      };
    }

    case GET_PHYSICIAN_NOTES.SUCCESS: {
      return {
        ...state,
        physicianNotes: payload.data.response.reverse(),
      };
    }

    case GET_PHYSICIAN_VISITS.SUCCESS: {
      return {
        ...state,
        physicianVisits: _.orderBy(payload.data.response, 'dateTime', 'desc'),
      };
    }

    case ADD_PHYSICIAN_NOTE.SUCCESS: {
      const newNote = { ...payload, id: new Date() };

      return {
        ...state,
        physicianNotes: [newNote, ...state.physicianNotes],
      };
    }

    case GET_PHYSICIAN_GROUP_NOTES.SUCCESS: {
      return {
        ...state,
        physicianGroupNotes: payload.data.response.reverse(),
      };
    }

    case ADD_PHYSICIAN_GROUP_NOTE.SUCCESS: {
      const newNote = { ...payload, id: new Date() };

      return {
        ...state,
        physicianGroupNotes: [newNote, ...state.physicianGroupNotes],
      };
    }

    case GET_PHYSICIAN_GROUP_USERS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_PHYSICIAN_GROUP_USERS.SUCCESS: {
      return {
        ...state,
        physicianGroupUsers: payload.data.response,
        requestStatus: 'success',
      };
    }

    default:
      return state;
  }
};

export default reducer;
